/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Choose_Parent_Group_And_User_RolesInputs */



/**
* | output |
* | --- |
* | "Choose parent group and user roles" |
*
* @param {Choose_Parent_Group_And_User_RolesInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const choose_parent_group_and_user_roles = /** @type {((inputs?: Choose_Parent_Group_And_User_RolesInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Choose_Parent_Group_And_User_RolesInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Choose parent group and user roles")
	return /** @type {LocalizedString} */ ("Choisir le groupe parent et les rôles utilisateurs")
});